// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2GS8fZyovuv1dGduBdvz9M","action":"_1XmGkZUsqVujVPR-hy0fKY","close":"_1khKJvrN6_nNrvNFNXpr8y"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Notification/Notification.css
// module id = 1056
// module chunks = 58